import React, { useEffect, useRef } from "react";
import Chart, { ChartConfiguration } from "chart.js/auto";

interface ChartProps {
  active: number;
  inactive: number;
  activeColor?: string;
  inactiveColor?: string;
  title: string;
  className?: string;
}

const DonutChart = (props: ChartProps) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstanceRef = useRef<Chart | null>(null);
  const {
    active,
    inactive,
    activeColor = "rgb(150, 222, 209)",
    inactiveColor = "rgb(250, 160, 160)",
    title,
    className,
  } = props;

  useEffect(() => {
    if (chartRef.current) {
      const dataDoughnut = {
        labels: [`Active: ${active}`, `Inactive: ${inactive}`],
        datasets: [
          {
            label: title,
            data: [active, inactive],
            backgroundColor: [activeColor, inactiveColor],
            hoverOffset: 4,
          },
        ],
      };

      const configDoughnut: ChartConfiguration<"doughnut", number[], string> = {
        type: "doughnut",
        data: dataDoughnut,
        options: { plugins: { legend: { position: "bottom" } } },
      };

      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      // @ts-ignore
      chartInstanceRef.current = new Chart(chartRef.current, configDoughnut);
    }
  }, [active, activeColor, inactive, inactiveColor, title]);

  return (
    <div className={` ${className}`}>
      <div className="py-3 px-5 text-[0.8rem] md:text-[1rem] lg:text-[1.2rem] font-semibold text-center text-gray-500">
        {title}
      </div>
      <canvas
        className="h-[10rem] md:max-h-[13rem] lg:max-h-[10rem]"
        ref={chartRef}
      ></canvas>
    </div>
  );
};

export default DonutChart;
